import { render, staticRenderFns } from "./ImageRound.vue?vue&type=template&id=407c2394&scoped=true&lang=pug&"
import script from "./ImageRound.vue?vue&type=script&lang=ts&"
export * from "./ImageRound.vue?vue&type=script&lang=ts&"
import style0 from "./ImageRound.vue?vue&type=style&index=0&id=407c2394&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407c2394",
  null
  
)

export default component.exports